<template>
  <div class="client-view p-10">
    <div class="bg-FFDA3E p-10" style="overflow: hidden;border-radius: 10px">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1">
          <template #title>
            <div class="flex">
              <div class="w-60 h-60 bg-FF text-center m-l-30 l-h-65" style="border-radius: 50%">
                <van-icon color="#FFDA3E" size="16" name="manager"/>
              </div>
              <div class="bg-FFDA3E font-32 font-weight-500 p-l-20 cor-3E3A39">
                {{ formData.companyName }}
              </div>
            </div>
            <div class="flex m-t-30">
              <div>
                <van-icon name="location"/>
              </div>
              <div class="font-28 cor-33 font-weight-400 m-l-10">
                {{ formData.companyPlace || '暂未录入地址' }}
              </div>
            </div>
          </template>
          <div>
            <van-row type="flex" align="center" v-if="formData.parentId">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">上级单位：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item class="font-24" @click.native="parentId.show = true" :value="formData.parentId"
                                  :isShowIcon="false"
                                  placeholder="请选择上级单位"
                                  :options="{data:parentId.data,showFields:'companyName',valueKey:'id',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">客户级别：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="companyLevel.show = true" :isShowIcon="false"
                                  :value="formData.companyLevel"
                                  placeholder="请选择客户级别"
                                  :options="{data:companyLevel.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">单位类型：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="companyNature.show = true" :isShowIcon="false"
                                  :value="formData.companyNature"
                                  :options="{data:companyNature.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
              <van-divider/>
             <van-row type="flex" align="center">
              <van-col span="6"> 

                <div class="font-24 cor-3E3A39">客户规模：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="customBase.show = true" :isShowIcon="false"
                                  :value="formData.customBase"
                                  :options="{data:customBase.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">行业：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="companyIndustry.show = true" :isShowIcon="false"
                                  :value="formData.companyIndustry"
                                  :options="{data:companyIndustry.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">客户来源：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="companySource.show = true" :isShowIcon="false"
                                  :value="formData.companySource.toString()"
                                  :options="{data:companySource.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">业务委托形式：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item @click.native="companyEntrustType.show = true" :isShowIcon="false"
                                  :value="formData.companyEntrustType"
                                  :options="{data:companyEntrustType.data,showFields:'dictLabel',valueKey:'dictValue',fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">法人：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item :isShowIcon="false" :text="formData.companyLegalPerson" :options="{fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">联系电话：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item :isShowIcon="false" :text="formData.companyTelephone" :options="{fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">地区：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item :isShowIcon="false" :text="formData.companyProvinceName" :options="{fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
            <van-divider/>
            <van-row type="flex" align="center">
              <van-col span="6">
                <div class="font-24 cor-3E3A39">成交笔数：</div>
              </van-col>
              <van-col span="18">
                <div class="cor-33">
                  <form-view-item :isShowIcon="false" :text="formData.contractNum" :options="{fontSize:'24'}"/>
                </div>
              </van-col>
            </van-row>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-tabs v-model="tabIndex" @click="tableClick" class="m-t-20">
      <van-tab name="0" title="联系人">
      </van-tab>
      <van-tab name="1" title="拜访记录">
      </van-tab>
    </van-tabs>
    <van-cell-group class="m-t-10" v-if="tabIndex == 0">
      <van-notice-bar
          left-icon="volume-o"
          text="本人创建的联系人可右滑修改。"
      />
      <div v-for="(item,i) in customer.list" :key="i">
        <van-swipe-cell :disabled="item.createBy != userInfo.userId">
          <div class="p-20 flex">
            <div>
              <div class="w-80 h-80 bg-FFDA3E font-36 text-center l-h-80" style="border-radius: 50%">
                {{ item.userName?.charAt(0) }}
              </div>
            </div>
            <div>
              <p class="font-30 cor-33 m-l-20">
                <span>{{ item.userName }}</span>
                <span class="m-l-20">{{ item.userTelephone }}</span>
              </p>
              <p class="font-30 cor-33 m-l-20 m-t-6">{{ item.userMobile }}</p>
            </div>
          </div>
          <template #right>
            <div style="height: 100%;background: #FFDA3E;" class="font-34 p-l-50 p-r-50" @click="edit(item)">
              <div style="position: relative;top: 50%;transform: translateY(-50%)">修改</div>
            </div>
          </template>
        </van-swipe-cell>
      </div>
    </van-cell-group>
    <div class="m-t-10" v-if="tabIndex == 1">
      <van-cell-group class="m-t-10 p-20" v-for="item in customerVisit.list" :key="item.id">
        <van-row @click="detail(item.id)" align="center">
          <van-row type="flex" align="center" justify="center">
            <van-col span="3">
              <van-icon class="p-t-20" size="30" name="friends" color="#FFDA3E"/>
            </van-col>
            <van-col span="19">
              <div class="sender-info">
                <span class="cor-33 font-30 font-weight-600">{{ item.customerCompanyName }}</span>
              </div>
            </van-col>
          </van-row>
          <van-row class="m-t-1" type="flex" align="center" justify="center">
            <van-col span="6">
              <span class="cor-88 font-28">拜访人</span>
            </van-col>
            <van-col span="18">
              <span class="cor-33 font-28">{{ item.customerUserName }}</span>
            </van-col>
          </van-row>
          <van-row class="m-t-1" type="flex" align="center" justify="center">
            <van-col span="6">
              <span class="cor-88 font-28">拜访时间</span>
            </van-col>
            <van-col span="18">
              <span class="cor-33 font-28">{{ item.visitTime }}</span>
            </van-col>
          </van-row>
          <van-row class="m-t-1" type="flex" align="top" justify="center">
            <van-col span="6">
              <span class="cor-88 font-28">拜访记录</span>
            </van-col>
            <van-col span="18">
              <span class="cor-33 font-28 hjj">{{ item.visitGoal }}</span>
            </van-col>
          </van-row>
          <van-divider></van-divider>
          <van-row type="flex" align="center" justify="center">
            <van-col span="18">
              <span class="font-28 cor-00">记录：</span>
              <span class="font-28 cor-00">{{ item.createByName }} {{ convertTime(item.createTime) }}</span>
            </van-col>
          </van-row>
        </van-row>
      </van-cell-group>

    </div>

  </div>
</template>
<script>
import {companyList, getCompany, getCustomerList, province} from '@/api/crm/index'
import formViewItem from "@/components/formViewItem/index.vue";
import {getDictDataByType} from "@/api/dict";
import {jurisdictionDeptTree} from "@/api/dept";
import cache from "@/plugins/cache";
import {getCustomerVisitAPI} from "@/api/visit";

class PickerOptions {
  constructor() {
    this.data = [];
    this.show = false;
    this.filteredData = [];
    this.filterText = '';
  }
}

export default {
  components: {formViewItem},
  data() {
    return {
      userInfo: {},
      customer: {
        queryParams: {
          pageNum: '1',
          pageSize: '20000',
          companyId: ''
        },
        list: []
      },

      customerVisit: {
        queryParams: {
          pageNum: '1',
          pageSize: '20000',
          customerCompanyId: ''
        },
        list: []
      },
      tabIndex: 0,
      parentId: new PickerOptions(),
      companyLevel: new PickerOptions(),
      customBase: new PickerOptions(),
      companyNature: new PickerOptions(),
      companyIndustry: new PickerOptions(),
      companySource: new PickerOptions(),
      companyEntrustType: new PickerOptions(),
      companyProvince: new PickerOptions(),
      companyCity: new PickerOptions(),
      companyArea: new PickerOptions(),
      activeNames: [],
      formData: {}
    }
  },
  created() {
    const {companyId} = this.$route.query
    this.userInfo = JSON.parse(cache.session.get('userInfo'))
    this.companyId = companyId
    this.customer.queryParams.companyId = companyId
    this.customerVisit.queryParams.customerCompanyId = companyId
    this.getCustomerList()
    getDictDataByType('customer_level').then(res => {
      this.companyLevel.data = res.data
      this.companyLevel.filteredData = res.data
    })
    getDictDataByType('custom_base').then(res => {
      this.customBase.data = res.data
      this.customBase.filteredData = res.data
    })
    getDictDataByType('customer_nature').then(res => {
      this.companyNature.data = res.data
      this.companyNature.filteredData = res.data
    })
    getDictDataByType('customer_industry').then(res => {
      this.companyIndustry.data = res.data
      this.companyIndustry.filteredData = res.data
    })
    getDictDataByType('company_source').then(res => {
      this.companySource.data = res.data
      this.companySource.filteredData = res.data
    })
    getDictDataByType('company_entrust_type').then(res => {
      this.companyEntrustType.data = res.data
      this.companyEntrustType.filteredData = res.data
    })
    province().then(res => {
      this.companyProvince.data = res.rows
      this.companyProvince.filteredData = res.rows
    })
    jurisdictionDeptTree().then(res => {
      this.jurisdictionDeptTree = res.data
    })
    this.getCompany()
    this.getParentCompanyList()
    this.getCustomerVisitAPI()
  },
  methods: {
    convertTime(timeString) {
      // 假设输入的时间格式是 "10:28:35"
      // 首先，我们需要将字符串转换为 Date 对象
      const dateMatch = timeString.match(/(\d{4}-\d{2}-\d{2})/);
      let datestr = dateMatch ? dateMatch[1] : '';
      const date = new Date(timeString);
      // 然后，我们提取小时和分钟
      const hours = date.getHours();
      const minutes = date.getMinutes();
      // 最后，我们将小时和分钟格式化为 "10:28" 格式
      const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes.toString() : minutes}`;
      return datestr + ' ' + formattedTime;
    },
    detail(id) {
      this.$router.push({path: '/visitDetails', query: {id: id}})
    },
    edit(item) {
      this.$router.push({path: "/customer/add", query: {customerId: item.id, companyId: item.companyId}})
    },
    getCustomerVisitAPI() {
      getCustomerVisitAPI(this.customerVisit.queryParams).then(res => {
        this.customerVisit.list = res.rows
        console.log(this.customerVisit.list)
      })
    },
    getCustomerList() {
      getCustomerList(this.customer.queryParams).then(res => {
        this.customer.list = res.rows
      })
    },
    tableClick() {
    },
    getCompany() {
      getCompany(this.companyId).then(res => {
        this.formData = res.data
        console.log(JSON.stringify(this.formData))
      })
    },
    getParentCompanyList() {
      this.restaurants = [];
      var queryParam = {
        pageNum: 1,
        pageSize: 10000,
      };
      companyList(queryParam).then(response => {
        this.parentId.data = response.rows;
        this.parentId.filteredData = response.rows;
        if (response.rows.length > 0) {
          response.rows.forEach(item => {
            this.restaurants.push({
              'value': item.companyName
            });
          })
        }
      });
    },
  }
}

</script>

<style scoped lang="less">

/deep/ .van-cell {
  background-color: #FFDA3E;
}

/deep/ .van-collapse-item__content {
  background-color: #FFDA3E;
  padding: 20px;
}
</style>
